import React from 'react';
import Card, {
	CardBody,
	CardFooter,
	CardHeader,
	CardLabel,
	CardSubTitle,
	CardTitle,
} from '../../components/bootstrap/Card';
import Button from '../../components/bootstrap/Button';
import Badge from '../../components/bootstrap/Badge';
import { priceFormat } from '../../helpers/helpers';
import { layoutMenu } from '../../menu';
import '../common/Card.css';
import useDarkMode from '../../hooks/useDarkMode';
import PlaceholderImage from '../../components/extras/PlaceholderImage';
import { useTranslation } from 'react-i18next';

const CommonGridProductItemSwl = ({
	id,
	name,
	category,
	img,
	price,
	pts,
	currency,
	service_lable,
}) => {
	const { t } = useTranslation();
	const { darkModeStatus } = useDarkMode();

	return (
		<Card className='card-cus' style={{ width: '90%', cursor: 'pointer' }}>
			<CardHeader>
				<CardLabel style={{ textAlign: 'left', width: '100%' }}>
					{/* <CardTitle style={{ fontSize: '15px' }}>{name}</CardTitle>
					<CardSubTitle style={{ fontSize: '10px' }}>{category}</CardSubTitle> */}
					<CardTitle style={{ fontSize: '15px' }}>
						{name.length > 26 ? name.substring(0, 26) + '...' : name}
					</CardTitle>
					<CardSubTitle style={{ fontSize: '10px' }}>
						{category.length > 18 ? category.substring(0, 18) + '...' : category}
					</CardSubTitle>
				</CardLabel>
			</CardHeader>
			<CardBody className='card-bdy'>
				<div className='card-img-wrapper'>
					{service_lable && service_lable.trim() !== '' && (
						<div className='corner-ribbon'>{service_lable}</div>
					)}
					{img ? (
						<img className='card-bdy-img' src={img} alt='' width={100} height={100} />
					) : (
						<PlaceholderImage
							width={250}
							height={150}
							className='mx-auto d-block img-fluid mb-3 rounded'
						/>
					)}
				</div>
				{price && (
					<Badge
						color='success'
						className='ms-2'
						style={{
							position: 'absolute',
							bottom: '15px',
							right: '30px',
							borderRadius: '2 2 2 2',
							fontSize: '12px',
						}}>
						{/* {currency + ' ' + priceFormat(price)} */}
						{(currency + ' ' + priceFormat(price)).length > 12
							? (currency + ' ' + priceFormat(price)).substring(0, 12) + '...'
							: currency + ' ' + priceFormat(price)}
					</Badge>
				)}
				{pts && pts !== '' && (
					<Badge color='primary' className='ms-2 card-badge-pts'>
						{t(pts + ' PTS')}
					</Badge>
				)}
			</CardBody>
			<CardFooter className='shadow-3d-container'>
				<Button
					color={darkModeStatus ? 'dark' : 'info'}
					className={`w-100 mb-4-${darkModeStatus ? 'light' : 'dark'}`}
					style={{
						fontSize: '12px',
						paddingBottom: '10px',
					}}
					size='lg'
					tag='a'
					to={`../${layoutMenu.view_servwl.path}/${id}`}>
					{t('View Service')}
				</Button>
			</CardFooter>
		</Card>
	);
};

export default CommonGridProductItemSwl;
